module.exports = __webpack_public_path__ + "static/media/Icon02.6c0d95c7.png";